import { Component, OnInit } from '@angular/core';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-useraccessskin',
  templateUrl: './useraccessskin.component.html',
  styleUrls: ['./useraccessskin.component.css'],
})
export class UseraccessskinComponent implements OnInit {
  display = true;
  schoolResolved = false;
  schoollogourl: string;
  schoolName: string;
  currentDate: Date = new Date();

  constructor(
    public headerinfo: ComponentheaderService,
    public util: UtilService
  ) { }

  async ngOnInit() {
    try {
      const school = await this.util.getStaticSchoolInfoBundle();
      this.schoollogourl = school?.schoolInfo?.logoImg;
      this.schoolName = school?.schoolInfo?.schoolName;
    }
    catch (err) {
      console.log(err);
    }
    // drives the intro copy, which reads badly with an empty school name
    this.schoolResolved = !!this.schoolName;
  }
}
